import { render, staticRenderFns } from "./ReservationEscalations.vue?vue&type=template&id=1c3f08f0&scoped=true&"
import script from "./ReservationEscalations.vue?vue&type=script&lang=js&"
export * from "./ReservationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./ReservationEscalations.vue?vue&type=style&index=0&id=1c3f08f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f08f0",
  null
  
)

export default component.exports